const data = {
  title: "Floor 5-7",
  musicTrack: "MUSIC_WORLD1",
  theme: "YELLOW",
  timeLimitSeconds: 120,
  tilesWidth: 9,
  tilesHeight: 9,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 8,
      y: 2
    },
    {
      type: "WATER",
      x: 3,
      y: 5
    },
    {
      type: "WATER",
      x: 5,
      y: 5
    },
    {
      type: "WATER",
      x: 6,
      y: 8
    },
    {
      type: "FIRE",
      x: 2,
      y: 6
    },
    {
      type: "FIRE",
      x: 8,
      y: 7
    },
    {
      type: "FIRE",
      x: 7,
      y: 7
    },
    {
      type: "FIRE",
      x: 6,
      y: 7
    },
    {
      type: "FIRE",
      x: 5,
      y: 7
    },
    {
      type: "FIRE",
      x: 4,
      y: 7
    },
    {
      type: "ICE",
      x: 2,
      y: 5,
      corner: "BOTTOM_LEFT"
    },
    {
      type: "ICE",
      x: 2,
      y: 4
    },
    {
      type: "ICE",
      x: 3,
      y: 4
    },
    {
      type: "CHIP",
      x: 8,
      y: 8
    },
    {
      type: "CHIP",
      x: 2,
      y: 8
    },
    {
      type: "CHIP",
      x: 5,
      y: 2
    },
    {
      type: "CHIP",
      x: 5,
      y: 8
    },
    {
      type: "CHIP",
      x: 5,
      y: 5
    },
    {
      type: "CHIP",
      x: 2,
      y: 5
    },
    {
      type: "CHIP",
      x: 8,
      y: 5
    },
    {
      type: "TELEPORT",
      x: 4,
      y: 8
    },
    {
      type: "TELEPORT",
      x: 4,
      y: 4
    },
    {
      type: "WATER",
      x: 5,
      y: 4
    },
    {
      type: "WATER",
      x: 4,
      y: 5
    },
    {
      type: "LOCK",
      x: 7,
      y: 8,
      color: "GREEN"
    },
    {
      type: "SWITCH",
      x: 6,
      y: 6
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 4,
      isRaised: true
    },
    {
      type: "ICE",
      x: 5,
      y: 2
    },
    {
      type: "WALL",
      x: 6,
      y: 2
    },
    {
      type: "WALL",
      x: 1,
      y: 8
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 8,
      isRaised: true
    },
    {
      type: "WALL",
      x: 5,
      y: 1
    },
    {
      type: "WATER_PICKUP",
      x: 8,
      y: 9
    },
    {
      type: "FIRE_BOOTS",
      x: 3,
      y: 1
    },
    {
      type: "ICE_BOOTS",
      x: 7,
      y: 5
    },
    {
      type: "THIEF",
      x: 8,
      y: 4
    },
    {
      type: "WALL",
      x: 9,
      y: 3
    },
    {
      type: "FIRE",
      x: 8,
      y: 1
    },
    {
      type: "FIRE",
      x: 9,
      y: 2
    },
    {
      type: "FIRE",
      x: 9,
      y: 1
    },
    {
      type: "FIRE",
      x: 7,
      y: 1
    },
    {
      type: "FIRE",
      x: 6,
      y: 1
    },
    {
      type: "WATER",
      x: 7,
      y: 6
    },
    {
      type: "WATER",
      x: 8,
      y: 6
    },
    {
      type: "WATER",
      x: 9,
      y: 6
    },
    {
      type: "WATER",
      x: 9,
      y: 4
    },
    {
      type: "WATER",
      x: 9,
      y: 5
    },
    {
      type: "WATER",
      x: 8,
      y: 5
    },
    {
      type: "WATER",
      x: 4,
      y: 9
    },
    {
      type: "WATER",
      x: 1,
      y: 1
    },
    {
      type: "WATER",
      x: 1,
      y: 2
    },
    {
      type: "WATER",
      x: 2,
      y: 1
    },
    {
      type: "WATER",
      x: 3,
      y: 1
    },
    {
      type: "WATER",
      x: 4,
      y: 1
    },
    {
      type: "ICE",
      x: 1,
      y: 3
    },
    {
      type: "ICE",
      x: 4,
      y: 2
    },
    {
      type: "ICE",
      x: 3,
      y: 3
    },
    {
      type: "ICE",
      x: 4,
      y: 3
    },
    {
      type: "CONVEYOR",
      x: 2,
      y: 8,
      direction: "DOWN"
    },
    {
      type: "THIEF",
      x: 3,
      y: 2
    },
    {
      type: "THIEF",
      x: 6,
      y: 9
    },
    {
      type: "KEY",
      x: 6,
      y: 8,
      color: "BLUE"
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 7,
      isRaised: false
    },
    {
      type: "THIEF",
      x: 6,
      y: 3
    },
    {
      type: "ICE",
      x: 5,
      y: 3
    },
    {
      type: "THIEF",
      x: 1,
      y: 4
    },
    {
      type: "ICE",
      x: 1,
      y: 5
    },
    {
      type: "ICE",
      x: 1,
      y: 6
    },
    {
      type: "ICE",
      x: 1,
      y: 7
    },
    {
      type: "LOCK",
      x: 7,
      y: 3,
      color: "GREEN"
    },
    {
      type: "WALL",
      x: 8,
      y: 3
    },
    {
      type: "KEY",
      x: 2,
      y: 6,
      color: "GREEN"
    },
    {
      type: "LOCK",
      x: 7,
      y: 2,
      color: "BLUE"
    },
    {
      type: "ENEMY_SPAWN",
      x: 4,
      y: 6,
      direction: "DOWN",
      enemyType: "FLYING_ENEMY"
    },
    {
      type: "ENEMY_SPAWN",
      x: 6,
      y: 5,
      direction: "LEFT",
      enemyType: "FLYING_ENEMY"
    }
  ]
};

export default data;
